// extracted by mini-css-extract-plugin
module.exports = {"modal_container":"Modal_modal_container__25xQG","modal":"Modal_modal__29GUz","btnC":"Modal_btnC__2lmR9"};